import log from '../../utils/log';

export const initTextReplacements = (textReplacements, formRef = {}) => {
  const searchScope = formRef.current || document;

  const mapTextForMultiNode = node => {
    const content = node.innerHTML;
    const regex = /{f\w*}/g;
    const matches = content.match(regex);
    if (!matches) {
      // nothing found
      return;
    }
    if (!textReplacements.current) {
      textReplacements.current = [];
    }
    textReplacements.current.push({
      ref: node,
      matches: matches,
      originalText: content
    });
  };

  const fields = searchScope.querySelectorAll('[field-id]');
  fields.forEach(fNode => {
    const fieldTitleNode =
      fNode.querySelector('h3') ||
      fNode.querySelector('div[role="instructional-text-title"]');

    const fieldDescriptionNodes = fNode.querySelectorAll(
      'div[role="field-description"]'
    );

    if (fieldTitleNode) {
      mapTextForMultiNode(fieldTitleNode);
    }

    fieldDescriptionNodes.forEach(fD => {
      mapTextForMultiNode(fD);
    });
  });
};

export const updateTextReplacements = (
  textReplacements,
  fieldChanged,
  formRef = {},
  customStatusesByMyFieldRef
) => {
  const customStatusesByMyField = customStatusesByMyFieldRef.current;

  const searchScope = formRef.current || document;
  textReplacements.current.forEach(data => {
    const { matches, originalText, ref } = data;
    let modifiedText = originalText;
    matches.forEach(rawFId => {
      const justFId = rawFId.replace('{', '').replace('}', '');
      const fieldScope = searchScope.querySelector(
        `div[field-id="${justFId}"]`
      );
      if (!fieldScope) {
        return;
      }
      const value = fieldScope.getAttribute('value');
      const statusesForThisField = customStatusesByMyField[justFId];
      if (value) {
        let valueWithStatusReplacements = value;
        if (statusesForThisField) {
          let keys = Object.keys(statusesForThisField);
          keys.forEach(one => {
            valueWithStatusReplacements = valueWithStatusReplacements.replace(
              '||' + one + '||',
              statusesForThisField[one]
            );
          });
        }
        modifiedText = modifiedText.replace(
          rawFId,
          valueWithStatusReplacements
        );
      }
    });
    ref.innerHTML = modifiedText;
  });
};
